import adminApiClient from '../../api/base/adminApiClient'

export interface StatsDay {
  date: string
  /** 그날 앱을 연 사람 수 (로그인 상태 요청 기준) */
  dau: number
  signups: number
  reviews: number
}

export interface StatsSummary {
  dau_today: number
  wau: number
  mau: number
  total_users: number
  active_users: number
  total_reviews: number
  total_places: number
  /** 활동 기록을 남기기 시작한 날 */
  tracking_since: string | null
}

/** DAU를 신규·유지·복귀로 나눈 값. 셋을 더하면 그날 DAU가 된다 */
export interface StatsBreakdownDay {
  date: string
  /** 그날 처음 들어온 사람 */
  new: number
  /** 최근 7일 안에도 들어왔던 사람 */
  retained: number
  /** 예전에 왔지만 최근 7일은 비어 있던 사람 */
  returning: number
}

export interface RetentionBucket {
  total: number
  returned: number
  rate: number
}

export interface FunnelStep {
  count: number
  rate: number
}

export interface Engagement {
  wau: number
  wau_with_review: number
  write_rate: number
  dormant_30d: number
  dormant_rate: number
}

/**
 * 경로별 클릭과 그 뒤 이야기.
 *
 * clicks는 download.html에서 스토어로 넘어간 수다(설치 수가 아니다).
 * signups 이후는 안드로이드 설치 귀속으로 계정에 붙은 값이라, iOS는 늘 0이다.
 */
export interface ChannelRow {
  source: string
  campaign: string
  clicks: number
  ios: number
  android: number
  other: number
  /** 그 경로로 설치해 가입한 계정 수 (안드로이드만) */
  signups: number
  /** 그중 기록을 하나라도 남긴 사람 */
  with_review: number
  /** 그중 최근 7일 안에 들어온 사람 */
  active_7d: number
}

export interface QuitUser {
  username: string
  quit_at: string
  /** 가입부터 탈퇴까지 머문 시간 (분) */
  stayed_minutes: number
  reviews: number
}

export interface QuitStats {
  total: number
  rate: number
  /** 가입 후 instant_minutes 안에 나간 사람 */
  instant: number
  instant_minutes: number
  /** 기록을 하나도 안 남기고 나간 사람 */
  without_review: number
  recent: QuitUser[]
}

export interface StatsResponse {
  daily: StatsDay[]
  breakdown: StatsBreakdownDay[]
  retention: Record<'d1' | 'd7' | 'd30', RetentionBucket>
  funnel: Record<
    'signed_up' | 'first_review' | 'three_reviews' | 'saved_place',
    FunnelStep
  >
  engagement: Engagement
  channels: ChannelRow[]
  quit: QuitStats
  summary: StatsSummary
}

export const adminStatsApi = {
  getStats: async (days = 30): Promise<StatsResponse> => {
    const response = await adminApiClient.get<StatsResponse>('/admin/stats', {
      params: { days },
    })
    return response.data
  },
}
